import type { ReactNode } from 'react';

export type CornerBadgeProps = {
  children: ReactNode;
};

/** Tilted "host" / "you" tag pinned to a polaroid's top-right corner. */
export const CornerBadge = ({ children }: CornerBadgeProps) => (
  <span
    className="absolute -top-2 right-1 z-[2] whitespace-nowrap border-[1.5px] border-ink bg-[var(--color-postit-warm)] px-1.5 py-0.5 font-display font-extrabold text-[10px] text-ink uppercase tracking-[0.16em] shadow-[2px_2px_0_rgba(0,0,0,.25)]"
    style={{ transform: 'rotate(8deg)' }}
  >
    {children}
  </span>
);
